import { FormPartComponent, MarketingConsent as MarketingConsentType } from "./FormParts";
import { useEffect } from "react";
import { useForm } from "@mantine/form";
import { shopVar } from "@/lib/shopStyles";

/**
 * A configurable marketing opt-in checkbox. Accepting it grants consent for the channels the organizer
 * configured on the form part (resolved server-side by the CDP ConsentSeeder). Optional by default; if
 * the organizer marked it required it must be checked to continue.
 */
export function MarketingConsent({ formPart, onValueChange, onValidStatusChange, answers }: FormPartComponent<MarketingConsentType>) {
    const form = useForm({
        mode: 'controlled',
        initialValues: {
            optIn: typeof answers === 'string' ? answers === "true" : false,
        },
        validateInputOnChange: ['optIn'],
        validate: {
            optIn: (value: boolean) => (!formPart.required || value ? null : 'Please confirm to continue'),
        },
        onValuesChange: (values) => {
            onValueChange(formPart.key, values.optIn ? "true" : "false");
            onValidStatusChange(formPart.key, form.isValid());
        }
    });

    useEffect(() => {
        // Submit the initial (unchecked) value + validity so an optional opt-in doesn't block the form.
        onValueChange(formPart.key, form.values.optIn ? "true" : "false");
        onValidStatusChange(formPart.key, form.isValid());
    }, []);

    return (
        <div className="relative flex items-start pt-4" data-form-part={formPart.key}>
            <div className="flex h-6 items-center">
                <input
                    id={`consent-${formPart.key}`}
                    name={formPart.key}
                    type="checkbox"
                    className="h-4 w-4 rounded border-gray-300 focus:ring-indigo-600"
                    style={{ color: '#222222' }}
                    {...form.getInputProps('optIn', { type: 'checkbox' })}
                />
            </div>
            <div className="ml-3 text-sm leading-6">
                <label htmlFor={`consent-${formPart.key}`} className="font-medium" style={{ color: shopVar('--shop-textColor') }}>
                    {formPart.label}
                </label>
                {formPart.description && <p className="text-sm text-gray-500">{formPart.description}</p>}
                {form.errors.optIn && <p className="text-sm text-red-600">{form.errors.optIn}</p>}
            </div>
        </div>
    );
}
